import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import '../types/cashFlow';
import {
  CashFlowExpenseByDateDetailItem,
  CashFlowExpenseByDateItem,
  CashFlowExpenseByDateRequest,
} from '../types/cashFlowExpenseByDate';

const cashFlowSchemas = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getCashFlowExpenseByDate: builder.query<CashFlowExpenseByDateItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseByDate/${data.id}`,
      }),
    }),
    changeCashFlowExpenseByDate: builder.mutation<void, PayloadRequest & CashFlowExpenseByDateItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseByDate/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createCashFlowExpenseByDate: builder.mutation<void, CashFlowExpenseByDateItem>({
      query: (data) => ({
        url: '/v1/CashFlowExpenseByDate',
        method: 'POST',
        body: data,
      }),
    }),

    getCashFlowExpenseByDateDetailList: builder.query<CashFlowExpenseByDateDetailItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseByDate/${data.id}/details`,
      }),
    }),
    getCashFlowExpenseByDateDetail: builder.query<CashFlowExpenseByDateDetailItem, CashFlowExpenseByDateRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseByDate/${data.cashFlowId}/details/${data.detailId}`,
      }),
    }),
    changeCashFlowExpenseByDateDetail: builder.mutation<void, CashFlowExpenseByDateDetailItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseByDate/${data.cashFlowId}/details/${data.detailId}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createCashFlowExpenseByDateDetail: builder.mutation<void, CashFlowExpenseByDateDetailItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseByDate/${data.cashFlowId}/details`,
        method: 'POST',
        body: data,
      }),
    }),
    deleteCashFlowExpenseByDateDetail: builder.mutation<void, CashFlowExpenseByDateRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseByDate/${data.cashFlowId}/details/${data.detailId}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useChangeCashFlowExpenseByDateMutation,
  useCreateCashFlowExpenseByDateMutation,
  useGetCashFlowExpenseByDateQuery,
  useLazyGetCashFlowExpenseByDateQuery,

  useGetCashFlowExpenseByDateDetailListQuery,
  useGetCashFlowExpenseByDateDetailQuery,
  useLazyGetCashFlowExpenseByDateDetailQuery,
  useDeleteCashFlowExpenseByDateDetailMutation,
  useCreateCashFlowExpenseByDateDetailMutation,
  useChangeCashFlowExpenseByDateDetailMutation,
} = cashFlowSchemas;
